import {
  Datagrid,
  List,
  TextField,
  DateField,
  Filter,
  TextInput,
  SelectInput,
  FunctionField,
  DateInput,
} from "react-admin";

const SMS_STATUS_CHOICES = [
  { id: 'sent', name: 'Sent' },
  { id: 'delivered', name: 'Delivered' },
  { id: 'failed', name: 'Failed' },
  { id: 'expired', name: 'Expired' },
  { id: 'rejected', name: 'Rejected' },
];

const SmsReportsFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="search" alwaysOn />
    <TextInput label="Phone Number" source="to" />
    <SelectInput
      source="status"
      choices={[
        { id: 'sent', name: 'Sent' },
        { id: 'delivered', name: 'Delivered' },
        { id: 'failed', name: 'Failed' },
      ]}
      optionText="name"
      optionValue="id"
      allowEmpty
    />
  </Filter>
);

const renderStatus = (record) => {
  const colorMap = {
    delivered: 'green',
    sent: 'blue',
    failed: 'red',
    expired: 'orange',
    rejected: 'darkred',
  };
  
  return (
    <span style={{ color: colorMap[record.status] || 'black' }}>
      {record.status}
    </span>
  );
};

export const SmsDeliveryReportsList = (props) => (
  <List 
    {...props} 
    filters={<SmsReportsFilter />} 

  >
    <Datagrid>
      <TextField source="id" />
      <TextField source="messageId" label="Message ID" />
      <TextField source="to" label="Phone Number" />
      <FunctionField 
        label="Status" 
        render={renderStatus} 
      />
      <TextField source="text" label="Message" ellipsis />
      <DateField source="submitDate" label="Submitted" showTime />
      <DateField source="doneDate" label="Completed" showTime />
      <DateField source="createdAt" label="Report Date" showTime />
    </Datagrid>
  </List>
);